import template from './selectTree.html'

export default function selectTreeDirective() {
    return {
        restrict: 'E',
        // 指令比较重要的 scope属性实现与控制器作用域的隔离与交互，反正就是作用域不影响而又可以传参交互
        scope: {
            // tree-model="fnTree" on-selection="onSelected(node)" on-collapse="onCollapse(node)"
            treeModel: '=', // 这里接受外部的参数 并且实现与外部参数的双向数据交互
            selectedModel: '=',
            onSelection: '&',
            onCollapse: '&',
            stChange: '=',
        },
        template,
        // link complir 这些函数少许区别 可以看下指令api 说明
        compile(element, attrs, link) {
            return function (scope, element, attrs) {
                const $collapseBox = $('.orgtree-content')
                scope.collapse = function (e, item) {
                    const $collapseBtn = $(e.target)
                    if ($collapseBtn.parent('.orgtree-top').hasClass('orgtree-top')) {
                        $collapseBtn.parent('.orgtree-top').next('.orgtree-content').slideToggle('fast')
                    } else if ($collapseBtn.parent().parent('.orgtree-top').hasClass('orgtree-top')) {
                        $collapseBtn.parent().parent('.orgtree-top').next('.orgtree-content').slideToggle('fast')
                    }
                    item.collapseFlag = !item.collapseFlag
                }
                var recursionChild = function (childNodes, parentNode, cb) {
                    for (const i in childNodes) {
                        cb(childNodes[i], parentNode)
                        if (childNodes[i].userList) {
                            recursionChild(childNodes[i].userList, childNodes[i], cb)
                        }
                    }
                }
                const setTreeSelected = function (treeData, selectedItems) {
                    // 递归树 比较选中项目 设置 selected

                    var recursionTree = function (nodes, cb) {
                        for (const i in nodes) {
                            cb(nodes[i])
                            if (nodes[i].userList) {
                                recursionTree(nodes[i].userList, cb)
                            }
                        }
                    }
                    recursionTree(treeData, (item) => {
                        if (item.uniqueUserId) {
                            item.selected = false
                            for (const i in selectedItems) {
                                if (selectedItems[i] !== '' && item.uniqueUserId == selectedItems[i]) {
                                    item.selected = true
                                }
                            }
                        }
                    })
                }
                // 初始化选中数据
                function selecteduserIdChange(newVal) {
                    if (newVal == undefined) {
                        return
                    }
                    var selectedArr = newVal.split(',')
                    setTreeSelected(scope.treeModel, selectedArr)
                    // 是否全选
                    for (const a in scope.treeModel) {
                        const subTree = scope.treeModel[a].userList


                        const len = subTree.length


                        let selectedCount = 0
                        for (const b in subTree) {
                            if (subTree[b].selected) {
                                selectedCount++
                            }
                        }
                        if (len > 0 && len === selectedCount) {
                            scope.treeModel[a].selected = true
                        } else {
                            scope.treeModel[a].selected = false
                        }
                    }
                    // 获取数据返回父极
                    var selectedArr = getSelectedItem(scope.treeModel)
                    scope.stChange && scope.stChange(selectedArr)
                }
                scope.$watch('selectedModel', selecteduserIdChange)

                // scope.$on('selectedOrgChange',function (event, data) {
                //     selecteduserIdChange(data);
                // })


                let getSelectedItem = function (treeData) {
                    // 递归树 获取选中项返回展平数组
                    const result = []
                    var recursionTree = function (nodes, cb) {
                        for (const i in nodes) {
                            cb(nodes[i])
                            if (nodes[i].userList) {
                                recursionTree(nodes[i].userList, cb)
                            }
                        }
                    }
                    recursionTree(treeData, (item) => {
                        if (item.uniqueUserId && item.selected == true) {
                            result.push(item)
                        }
                    })
                    return result
                }

                const singleClick = function (node, parentNodes) {
                    const flag = node.selected
                    const childNode = node.userList

                    // 全选取消 通知 下级
                    if (childNode) {
                        recursionChild(childNode, node, (item) => {
                            item.selected = flag
                            for (const i in scope.treeModel) {
                                for (const j in scope.treeModel[i].userList) {
                                    if (scope.treeModel[i].userList[j].userName === item.userName) {
                                        scope.treeModel[i].userList[j].selected = item.selected
                                    }
                                }
                            }
                        })
                    }
                    // 迭代同级 冒泡通知上级
                    if (parentNodes) {
                        for (const p in parentNodes) {
                            if (Object.hasOwnProperty.call(parentNodes, p)) {
                                var selectedCount = 0
                                const siblingNodes = parentNodes[p].userList.length
                                recursionChild(parentNodes[p].userList, parentNodes[p], (item, parentNode) => {
                                    // 统计
                                    if (item.selected == true) {
                                        selectedCount++
                                    }
                                })
                                if (selectedCount == siblingNodes) {
                                    parentNodes[p].selected = true
                                } else {
                                    parentNodes[p].selected = false
                                }
                            }
                        }
                    }
                }

                scope.onSelect = function (node, parentNodes) {
                    singleClick(node, parentNodes)
                    if (!node.userList) {
                        for (const i in scope.treeModel) {
                            for (const j in scope.treeModel[i].userList) {
                                if (scope.treeModel[i].userList[j].userName === node.userName) {
                                    scope.treeModel[i].userList[j].selected = node.selected
                                }
                            }
                        }
                    }
                    // 获取数据返回父极
                    const selectedArr = getSelectedItem(scope.treeModel)
                    scope.stChange && scope.stChange(selectedArr)
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/selectTree3/selectTreeDirective.js